import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuthStore((s) => ({ isAuthenticated: s.isAuthenticated, user: s.user }))
  if (!isAuthenticated) return <Navigate to="/auth/login" replace />
  if (!user?.is_admin) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
